import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Home, Building2, KeyRound } from "lucide-react";
import BuyImg from "../../../assets/images/buy.png";
import SellImg from "../../../assets/images/sell.png";
import RentImg from "../../../assets/images/rent.png";
import "./PropertyPurpose.css";

const CARDS = [
  {
    icon: Home,
    title: "Buy a Property",
    description:
      "Explore thousands of verified homes, luxury villas, and prime plots with transparent pricing and direct builder or owner connect.",
    image: BuyImg,
    btnText: "Search Properties",
    linkTo: "/property-list?purpose=Buy",
    badge: "Verified Deals",
  },
  {
    icon: Building2,
    title: "Sell a Property",
    description:
      "Showcase your property to genuine buyers across India. Gain maximum exposure, verified inquiries, and quick deal closures.",
    image: SellImg,
    btnText: "List Your Property",
    linkTo: "/partner/signup",
    badge: "Zero Brokerage",
  },
  {
    icon: KeyRound,
    title: "Rent a Property",
    description:
      "Find rental homes and fully furnished apartments matching your lifestyle, budget, and daily commute with complete peace of mind.",
    image: RentImg,
    btnText: "Explore Rentals",
    linkTo: "/property-list?purpose=Rent",
    badge: "Instant Move-In",
  },
];

const PropertyPurpose = () => (
  <section className="type-section">
    <div className="type-section__container">
      <div className="type-section__header">
        <span className="type-section__label">What are you looking for?</span>
        <h2 className="type-section__title">
          Explore Your <em>Property Options</em>
        </h2>
        <p className="type-section__subtitle">
          Whether buying, renting, or selling, All Home Desire makes your real estate journey effortless and reliable.
        </p>
      </div>

      <div className="type-section__grid">
        {CARDS.map(({ icon: Icon, title, description, image, btnText, linkTo, badge }) => (
          <div key={title} className="type-section__card">
            <div className="type-section__card-top">
              <span className="type-section__badge">{badge}</span>
              <div className="type-section__icon-wrap">
                <Icon size={20} />
              </div>
            </div>

            <div className="type-section__card-img-wrap">
              <img src={image} alt={title} className="type-section__card-img" />
            </div>

            <h3 className="type-section__card-title">{title}</h3>
            <p className="type-section__card-text">{description}</p>

            <Link to={linkTo} className="type-section__card-btn">
              <span>{btnText}</span>
              <ArrowRight size={15} strokeWidth={2.5} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PropertyPurpose;
